<template>
<!-- Container -->  

<div class="container">
  <div class="row my-5">
    <div class="col-12 d-flex justify-content-center">
      <h1>TRAILFINDERS TRAVEL INSURANCE</h1>
    </div>
  </div>


  <div class="row">
    <!-- QUOTE SUMMARY -->
    <div class="col-12 col-md-4">
      <div>
        <div
          title="Quote Summary"
          class="mb-2 card"
        >
          <div class="tf-vue-bg-grey-light p-2">
            <h6>Please make sure that you have provided the correct information</h6>
            <hr/>
            <ul>
              <li>Country of residence:<br/><strong>{{tripDetails.residence}}</strong></li>
              <li v-if="tripDetails.quoteType === 'SINGLEG'">
                Travelling to:<br/><strong>{{tripDetails.destination}}</strong>
              </li>
              <li v-if="tripDetails.quoteType === 'ANNUALG'">
                Worldwide Cover:<br/><strong>1 Year</strong>
              </li>
              <li v-if="tripDetails.quoteType === 'SINGLEG'">
                From:<br/><strong>{{fromDate}}</strong>
              </li>
              <li v-if="tripDetails.quoteType === 'SINGLEG'">
                To:<br/><strong>{{toDate}}</strong>
              </li>
              <li>
                Number of people:<br/>
                <strong v-html="tripDetails.numberPeopleString"></strong>
              </li>
              <li v-if="tripDetails.totalAdults === 2 && tripDetails.quoteType === 'ANNUALG'">
                <strong>Adults must be partners or spouse</strong>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>

    <!-- SINGLE TRIP QUOTE -->
    <div class="col-12 col-md-4">
      <div
        title="Single Trip"
        class="mb-2 justify-content-center"
      >
        <div>
          <h1 class="d-flex justify-content-center">{{defaultSite.symbol}}{{quoteSingle.PREMIUM}}</h1>
          <!-- form -->
          <form novalidate @submit="submitSingle" name="singleForm">
            <hr/>
            <div class="form-group">
              <div class="radio-group">

                <!-- FAMILY DISCOUNT -->
                <div class="row" v-if="showFamily">
                  <div class="col-sm-6 col-md-5">
                    <p>Family discount</p>
                  </div>
                  <div class="col-10 col-sm-5 col-md-6">
                    <input type="radio" id="select-famS-y" value="1" name="family-radio" v-model="familySingle" />
                    <label for="select-famS-y">Yes</label>
                    <input type="radio" id="select-famS-n" value="0" name="family-radio" v-model="familySingle" />
                    <label for="select-famS-n">No</label>
                  </div>
                </div>

                <!-- WINTER SPORTS -->
                <div class="row">
                  <div class="col-sm-6 col-md-5">
                    <p>Add winter sports cover</p>
                  </div>
                  <div class="col-10 col-sm-5 col-md-6">
                    <input type="radio" id="select-winterS-y" value="1" name="winter-radio" v-model="winterSingle" @change="addExtrasSingle" />
                    <label for="select-winterS-y">Yes</label>
                    <input type="radio" id="select-winterS-n" value="0" name="winter-radio" v-model="winterSingle" @change="addExtrasSingle" />
                    <label for="select-winterS-n">No</label>
                  </div>
                </div>

                <!-- CRUISE -->
                <div class="row">
                  <div class="col-sm-6 col-md-5">
                    <p>Add cruise cover</p>
                  </div>
                  <div class="col-10 col-sm-5 col-md-6">
                    <input type="radio" id="select-cruiseS-y" value="1" name="cruise-r" v-model="cruiseSingle" @change="addExtrasSingle" />
                    <label for="select-cruiseS-y">Yes</label>
                    <input type="radio" id="select-cruiseS-n" value="0" name="cruise-r" v-model="cruiseSingle" @change="addExtrasSingle" />
                    <label for="select-cruiseS-n">No</label>
                  </div>
                </div>
      
                    
                  <!-----IRELAND SPECIFC--->
                <div class="row" v-if="defaultSite.domain === 'ie'">
                  <div class="col-sm-6 col-md-5">
                    <small>
                      25% discount<br/>if you have Private Health 
                      insurance which provides overseas medical expenses cover
                    </small>
                  </div>
                  <div class="col-10 col-sm-5 col-md-6">
                    <input type="radio" id="select-25-y" value="1" name="25-r" v-model="dubSingle" @change="addExtrasSingle" />
                    <label for="select-25-y">Yes</label>
                    <input type="radio" id="select-25-n" value="0" name="25-r" v-model="dubSingle" @change="addExtrasSingle" />
                      No
                    <label for="select-25-n">No</label>
                  </div>
                </div>
                  <!-----CAR HIRE-->
                <div class="row">
                  <div class="col-10 col-sm-11 col-md-11">
                    <small>Call us to add Car Hire Damage Excess Waiver for
                      <strong v-if="defaultSite.domain !== 'ie'">&pound;5</strong>
                      <strong v-if="defaultSite.domain === 'ie'">&euro;5</strong>
                      per day (minimum 3 days)
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <!-- /form -->

          <div class="tf-vue-tag tf-vue-tag-child">
            <span class="text-white">Children included free of charge</span>
          </div>

        </div>
      </div>
    </div>

    <!-- ANNUAL TRIP QUOTE -->
    <div class="col-12 col-md-4">
      <div  
        title="Annual Multi-Trip"
        class="mb-2 card"
      >
        <div class="tf-vue-bg-grey-dark p-2">
          <h1 class="d-flex justify-content-center">{{defaultSite.symbol}}{{quoteAnnual.PREMIUM}}</h1>
          <div v-if="tripDetails.totalAdults === 2" style="text-align: center;">
            <strong>Adults must be partners or spouse</strong>
          </div>

          <form novalidate @submit="submitAnnual" name="multiForm">
            <hr/>     
            <div class="form-group">
              <div class="radio-group less-margin">
                
              <!-- MULTI FAMILY DISCOUNT  -->
                <div class="row less-padding" v-if="showFamily">
                  <div class="col-10 col-lg-11">
                    <small>Family discount</small>
                  </div>
                  <!-- <div 
                    class="col-2 col-lg-1">
                    <a 
                      href="#" 
                      class="question-mark float-end" 
                      data-bs-toggle="modal"
                      data-bs-target="#familyA">
                      <span
                        class="glyphicon glyphicon-question-sign"
                        aria-hidden="true">
                      </span>
                    </a>
                  </div> -->
                </div>
                <!-- MULTI WINTER SPORTS  -->
                <div class="row less-padding">
                  <div class="col-10 col-lg-11 mb-3">
                    <small>Winter sports cover automatically
                    <strong>included</strong></small>
                  </div>
                  <!-- <div class="col-2 col-lg-1">
                    <a 
                      href="#" 
                      class="question-mark float-end" 
                      data-bs-toggle="modal"
                      data-bs-target="#myModal-mt1">
                      <span
                        class="glyphicon glyphicon-question-sign"
                        aria-hidden="true">
                      </span>
                    </a>
                  </div> -->
                </div>

                  <!-- MULTI CRUISE -->
                <div class="row less-padding">
                  <div class="col-sm-6 col-md-5">
                    <p>Add cruise cover</p>
                  </div>
                  <div class="col-xs-10 col-sm-5 col-md-6">
                    <input type="radio" id="select-cruiseA-y" value="1" name="cruise-r" v-model="cruiseAnnual" @change="addExtrasAnnual" />
                    <label for="select-cruiseA-y">Yes</label>
                    <input type="radio" id="select-cruiseA-n" value="0" name="cruise-r" v-model="cruiseAnnual" @change="addExtrasAnnual" />
                    <label for="select-cruise-A-n">No</label>
                  </div>
                </div>

                <!-----MULTI IRELAND SPECIFC--->
                <div v-if="defaultSite.domain === 'ie'" class="row less-padding">
                  <div class="col-sm-6 col-md-5">
                      <small>
                      25% discount<br/>if you have Private Health insurance which
                      provides overseas medical expenses cover
                    </small>
                  </div>
                  <div class="col-10 col-sm-5 col-md-6">
                    <input type="radio" id="select-dubdiscA-y" value="1" name="dubdisc-r" v-model="dubAnnual" @change="addExtrasAnnual" />
                    <label for="select-dubdiscA-y">Yes</label>
                    <input type="radio" id="select-dubdiscA-n" value="0" name="dubdisc-r" v-model="dubAnnual" @change="addExtrasAnnual" />
                    <label for="select-dubdiscA-n">No</label>
                  </div>
                </div>

              </div>
            </div>
          </form><!-- /form -->

          <div class="tf-vue-tag">
            <span class="text-white">Best Seller</span>
          </div>
          <div class="tf-vue-tag tf-vue-tag-child">
            <span class="text-white">Children included free of charge</span>
          </div>
          
        </div>
      </div>
    </div>

   <div class="row">
    <div class="col-12 d-flex justify-content-center mt-5">
      <button class="btn btn-primary" @click="goBack">
        Go Back
      </button>
    </div>
  </div>

  </div>
   <div class="row justify-content-center">
    <div class="col-12 col-sm-4 mt-5">
      <div class="form-group text-center">
        <h4 for="ageCalc">Age Calculator</h4>
        <input type="date" id="ageCalc" v-model="dOB" class="mb-2 form-control" />
        <p class="fw-bold">AGE: {{age}}</p>
      </div>
    </div>
  </div>
   
</div>

  <!-- /Container -->
</template>
<script>
import moment from 'moment'
import { fetchQuote } from '@/services/api.js'
import { mapActions, mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'

export default {
  props: ['defaultSite'],
  data() {
    return {
      showFamily: Boolean,
      modalSingleType: 'SINGLEG',
      modalAnnualType: 'MULTI',
      isActive: true,
      dOB: ''
    }
  },
  created(){
    if(!this.tripDetails.totalAdults){
      this.$router.push("/step1")
    }
    this.showFamily = this.showFamilyCondition
  },
  computed: {
    ...mapFields({
      familySingle: 'quoteSingle.FAMILYDISCOUNT',
      winterSingle: 'quoteSingle.WINTERSPORT',
      cruiseSingle: 'quoteSingle.CRUISE',
      dubSingle: 'quoteSingle.DUBDISCOUNT',
      cruiseAnnual: 'quoteAnnual.CRUISE',
      dubAnnual: 'quoteAnnual.DUBDISCOUNT'
    }),
    ...mapGetters({
      quoteSingle: 'getQuoteSingle',
      quoteAnnual:  'getQuoteAnnual', 
      tripDetails: 'getTripDetailsInfo',
      step1: 'getStep1'
    }),  
    isKBInternal() {
      return process.env.VUE_APP_INTERNAL === 'true' ? true : false 
    },
    showFamilyCondition() {
    // when to show family discount
    let showFamily = false
    if ((
      this.tripDetails.quoteType === 'SINGLEG' && 
      this.tripDetails.totalNumberOfPeople > 2 && 
      this.quoteSingle.CHILDREN > 1 && 
      this.quoteSingle.CHILDREN < 7) || 
      (this.tripDetails.quoteType === 'ANNUALG' && 
      this.tripDetails.totalAdults > 1)) {
        showFamily = true
      }
      return showFamily
    }, 
    age() {
      return moment().diff(moment(this.dOB), 'years')
    },
    durationDays() {
      return moment(this.tripDetails.toDate,'DD-MM-YYYY').diff(moment(this.tripDetails.fromDate,'DD-MM-YYYY'), 'days') + 1
    },
    fromDate() {
      return moment(this.tripDetails.fromDate, 'DD-MM-YYYY').format('D MMMM YYYY')
    },
    toDate() {
      return moment(this.tripDetails.toDate, 'DD-MM-YYYY').format('D MMMM YYYY')
    },			
  },
  methods: {
    ...mapActions([
    'updateQuoteSingle',
    'updateQuoteAnnual',
    'fetchQuoteInfoSingle',
    'fetchQuoteInfoAnnual',
    'updatePremiumSingle',
    'updatePremiumAnnual',
    'updateQuoteType'
    ]),
    async addExtrasSingle() {
      let res = await fetchQuote(this.quoteSingle)
        this.updateQuoteSingle(this.quoteSingle)
        this.fetchQuoteInfoSingle({ response: res })
        this.updatePremiumSingle(res.premium)
      .catch( () => {
        this.quoteError = true
      })
    },
    async addExtrasAnnual() {
      let res = await fetchQuote(this.quoteAnnual)
        this.updateQuoteAnnual(this.quoteAnnual)
        this.fetchQuoteInfoAnnual({ response: res })
        this.updatePremiumAnnual(res.premium)
      .catch( () => {
        this.quoteError = true
      })
    },
    // SUBMIT
    submitSingle() {
      this.updateQuoteSingle(this.quoteSingle)
      this.updateQuoteType('SINGLEG')
      this.$router.push('/step3')
    },
    submitAnnual() {
      this.updateQuoteAnnual(this.quoteAnnual)
      this.updateQuoteType('ANNUALG')
      this.$router.push('/step3')
    },
    goBack() {
      this.$router.push('/')
    },
  },
  
  
}
</script>
<style scoped>

</style>